module.exports = __webpack_public_path__ + "static/media/invite.45134e72.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dealroom-icons/invite.svg
// module id = 2370
// module chunks = 0